var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status-box",class:_vm.classes},[_c('div',{staticClass:"status-box__item",style:({backgroundColor: _vm._color})})])}
var staticRenderFns = []

export { render, staticRenderFns }